import Header from "./Header";
import tooth from '../assets/tooth.png';

function NotFound() {

    return (
        <div>
            <Header authButton background sticky />
            <div className="NotFound">
                <div className="row">
                    <div className="col-12 d-flex justify-content-center align-items-center">
                        <div className="text-center">
                            <h1>4<span><img src={tooth} className="img-fluid" alt="0"></img></span>4</h1><br />
                            <p className="text-center">Page not found!</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default NotFound;